export const SUPPORTED_CODES = new Set([
    "en-GB",
    "ar",
    "bn-BD",
    "cs-CZ",
    "da-DK",
    "de-CH",
    "de-DE",
    "es-ES",
    "fi-FI",
    "fr-FR",
    "hu-HU",
    "it-IT",
    "lv-LV",
    "nl-BE",
    "nl-NL",
    "nn-NO",
    "pl-PL",
    "pt-PT",
    "sk-SK",
    "sv-SE",
    "uk-UA",
    "zh-CN",
    "pa-PK",
    "ps-PK",
    "ur-PK"
]);

const REGIONAL_MAPPINGS = {
    "pt-BR": "pt-PT",
    pt: "pt-PT",
    "es-MX": "es-ES",
    "es-AR": "es-ES",
    "es-CL": "es-ES",
    "es-CO": "es-ES",
    "es-US": "es-ES",
    "es-PE": "es-ES",
    "es-VE": "es-ES",
    es: "es-ES",
    "fr-CA": "fr-FR",
    "fr-BE": "fr-FR",
    "fr-CH": "de-CH",
    fr: "fr-FR",
    "de-AT": "de-DE",
    de: "de-DE",
    "en-US": "en-GB",
    "en-AU": "en-GB",
    "en-CA": "en-GB",
    "en-NZ": "en-GB",
    "en-IE": "en-GB",
    "en-ZA": "en-GB",
    en: "en-GB",
    "zh-TW": "zh-CN",
    "zh-HK": "zh-CN",
    zh: "zh-CN",
    "it-CH": "it-IT",
    it: "it-IT",
    nl: "nl-NL",
    da: "da-DK",
    sv: "sv-SE",
    no: "nn-NO",
    nb: "nn-NO",
    "nb-NO": "nn-NO",
    fi: "fi-FI",
    pl: "pl-PL",
    cs: "cs-CZ",
    sk: "sk-SK",
    "sk-CZ": "sk-SK",
    uk: "uk-UA",
    lv: "lv-LV",
    "bn-IN": "bn-BD",
    bn: "bn-BD",
    hu: "hu-HU",
    pa: "pa-PK",
    "pa-IN": "pa-PK",
    ps: "ps-PK",
    ur: "ur-PK",
    "ur-IN": "ur-PK",
    "ar-SA": "ar",
    "ar-AE": "ar",
    "ar-EG": "ar",
    "ar-IQ": "ar"
};

export const DEFAULT_LANGUAGE = "en-GB";

/**
 * Normalises a language code to BCP 47 form: lowercase language, uppercase region.
 * e.g. "IT" → "it", "it-it" → "it-IT", "EN-gb" → "en-GB"
 */
function normalizeCode(code) {
    if (typeof code !== "string") return code;
    const parts = code.split("-");
    if (parts.length === 1) return parts[0].toLowerCase();
    return parts[0].toLowerCase() + "-" + parts[1].toUpperCase();
}

/**
 * Resolves any language code to a supported code.
 * Used by the members portal (browser language detection) and web-components.
 *
 * Returns the code itself if supported, otherwise checks regional mappings,
 * then base language (e.g. "de" from "de-AT"), then falls back to en-GB.
 */
export function resolveLanguage(code) {
    if (!code) return DEFAULT_LANGUAGE;

    const normalized = normalizeCode(code);
    if (SUPPORTED_CODES.has(normalized)) return normalized;
    if (REGIONAL_MAPPINGS[normalized]) return REGIONAL_MAPPINGS[normalized];

    const base = normalized.split("-")[0];
    if (base !== normalized) {
        if (REGIONAL_MAPPINGS[base]) return REGIONAL_MAPPINGS[base];
        if (SUPPORTED_CODES.has(base)) return base;
    }

    return DEFAULT_LANGUAGE;
}

/**
 * i18next-compatible fallbackLng function.
 * Resolves any code to [supportedCode, "en-GB"].
 */
export function fallbackLng(code) {
    const resolved = resolveLanguage(code);
    if (resolved === DEFAULT_LANGUAGE) return [DEFAULT_LANGUAGE];
    return [resolved, DEFAULT_LANGUAGE];
}
